import { useNavigate, useLocation } from "react-router-dom";
import { isNavItemActive } from "@/shared/utils/navigationConfig";

/** Shorter labels so five tabs fit without crowding on small phones. */
const TAB_LABELS = {
  Dashboard: "Home",
  Contacts: "Contacts",
  Campaigns: "Campaigns",
  Accounts: "Accounts",
  "AI Trainer": "AI",
  Members: "Members",
  "Pending Requests": "Pending",
  Organizations: "Orgs",
};

const MobileNavItem = ({ navLink, badge, onNavigate }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isActive = isNavItemActive(pathname, navLink);
  const IconComponent = navLink.iconType;
  const displayBadge = badge ?? navLink?.badge;
  const isLucideIcon = typeof IconComponent === "function" && !navLink?.image;
  const label = TAB_LABELS[navLink.title] ?? navLink.title;

  const handleClick = () => {
    if (navLink.disabled) return;
    navigate(navLink.url);
    onNavigate?.();
  };

  return (
    <button
      type="button"
      role="tab"
      aria-selected={isActive}
      aria-label={navLink.title}
      aria-current={isActive ? "page" : undefined}
      disabled={navLink.disabled}
      onClick={handleClick}
      className="relative flex min-w-0 flex-1 flex-col items-center justify-center gap-1 px-1 pb-2 pt-2.5 outline-none transition-colors duration-150 disabled:opacity-40 focus-visible:ring-2 focus-visible:ring-secondary/30 focus-visible:ring-offset-2"
    >
      {isActive ? (
        <span
          aria-hidden="true"
          className="absolute inset-x-3 top-0 h-0.5 rounded-full bg-secondary"
        />
      ) : null}

      <span className="relative flex h-6 w-6 shrink-0 items-center justify-center">
        {navLink?.image ? (
          <img
            src={navLink.iconType}
            alt=""
            className={`h-5 w-5 ${isActive ? "opacity-100" : "opacity-55"}`}
          />
        ) : isLucideIcon ? (
          <IconComponent
            size={22}
            strokeWidth={isActive ? 2.25 : 1.75}
            className={isActive ? "text-secondary" : "text-gray-400"}
          />
        ) : (
          <IconComponent
            className="h-5 w-5"
            color={isActive ? "#207C97" : "#A4A7AE"}
          />
        )}
        {displayBadge != null && displayBadge > 0 ? (
          <span className="absolute -right-1.5 -top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-error-500 px-0.5 text-[9px] font-semibold leading-none text-white">
            {displayBadge > 9 ? "9+" : displayBadge}
          </span>
        ) : null}
      </span>

      <span
        className={`max-w-full truncate text-[11px] leading-none ${
          isActive
            ? "font-semibold text-secondary"
            : "font-medium text-gray-500"
        }`}
      >
        {label}
      </span>
    </button>
  );
};

export default MobileNavItem;
